import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import { invalidateMetaLeadsEventsTableQuery } from "hooks/useMetaLeadsEventsTable";
import DeleteMetaLeadsEventModal from "routes/meta_leads_events/components/DeleteMetaLeadsEventModal";
import MetaLeadsEventModal from "routes/meta_leads_events/components/MetaLeadsEventModal";

export function MetaLeadsEventsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const canEdit = useAuthorized([ACL_RELATIONSHIPS.metaLeadsEvent.edit]);
  const canDelete = useAuthorized([ACL_RELATIONSHIPS.metaLeadsEvent.delete]);

  if (!canEdit && !canDelete) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Event actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <MetaLeadsEventModal
        event={original}
        open={editOpen}
        onOpenChange={setEditOpen}
        onSuccess={invalidateMetaLeadsEventsTableQuery}
      />
      <DeleteMetaLeadsEventModal
        event={original}
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        onSuccess={invalidateMetaLeadsEventsTableQuery}
      />
    </>
  );
}
